import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

const Series = () => {
    const IMGPATH = "https://cdn.discordapp.com/attachments/";
    const [seriesFiltred, setSeriesFiltred] = useState(null);
    const [isOpen, setIsOpen] = useState(0);
    let numb = 0;
    let { id } = useParams();

    /* Sending data to useState to use it on page*/
    useEffect(() => {
        const getSeries = async () => {
            await fetchSeries();
        };
        getSeries();
    }, []);

    /* Fetching from a URL data */
    const fetchSeries = async () => {
        const res = await fetch("../gu.json", {
            headers: {
                "Access-Control-Allow-Origin": "application/json",
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const data = await res.json();
        const result = data.data.filter((item) => {
            return item.id.toString() === id;
        });

        setSeriesFiltred(...result);
    };

    function handleClick(event, id) {
        setIsOpen(id);
    }

    const Episodes = () => {
        let epi = [];
        seriesFiltred.episodes.map((ep) => {
            epi.push(
                <div
                    key={ep.id}
                    onClick={(e) => {
                        handleClick(e, ep.id);
                    }}
                    className="downed"
                >
                    <div className="odcinek">
                        <a href="#topnav">E{ep.id}</a>
                    </div>
                </div>
            );
        });
        return epi;
    };

    return (
        <>
            {seriesFiltred && (
                <div className="Main-center-flex">
                    <div className="glowna1">
                        <div className="prawo-sec">
                            {isOpen === 0 ? (
                                <>
                                    <h3>{seriesFiltred.overview}</h3>
                                </>
                            ) : (
                                <>
                                    <h3>Odcinek {isOpen}</h3>
                                    {seriesFiltred.episodes.map((serie) => {
                                        return (
                                            serie.id === isOpen && (
                                                <iframe
                                                    key={serie.id}
                                                    title={serie.id}
                                                    src={serie.url}
                                                    width="820"
                                                    height="530"
                                                    style={{ border: "none" }}
                                                    frameBorder="0"
                                                    scrolling="no"
                                                    allowFullScreen
                                                    name="v2"
                                                ></iframe>
                                            )
                                        );
                                    })}
                                </>
                            )}
                        </div>
                        <div className="prawo-thir">
                            <div className="lista">
                                <Episodes />
                            </div>
                        </div>
                    </div>
                    <div className="prawo-fir">
                        <div className="glowna1">
                            <img src={IMGPATH + seriesFiltred.photo_path} alt={seriesFiltred.title} />
                            <h3>{seriesFiltred.title}</h3>
                            <h5>Data Wydania: {seriesFiltred.release_date} </h5>
                            <h5>Typ: {seriesFiltred.type}</h5>
                            <h5>Epizody : {seriesFiltred.episodes.length} </h5>
                            <h5>Dlugosc : {seriesFiltred.epizod}</h5>
                            <h5>
                                Genres:
                                <ul>{seriesFiltred.genre.map((gen) => (gen !== "" ? <li key={(numb += 1)}>{gen}</li> : gen))}</ul>
                            </h5>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Series;
